import { Component, EventEmitter, Input, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../../../services/Session';
import { LoadingService } from '../../../services/LoadingService';
import { StateService } from '../../../services/StateService';
import {TodoServices} from '../../../services/todos.service';
import {State} from "../../../models/State";
import { CommonModule } from '@angular/common';

declare const _: any;
declare const jQuery: any;
declare const moment: any;

@Component({
  selector: 'app-tpiq-customer-dashboard-todos',
  standalone: true,
  templateUrl: './customer-dashboard-todos.html',
  imports: [CommonModule],
})
export class CustomerDashboardTodosComponent implements OnInit, OnDestroy {
  @Input() selectedYear: any; 
  org: string = Session.getOrg();
  user: any = {};
  userId: string;
  channelId = '';
  channelType = '';
  type = 'all';
  index = 0;
  columns: Array<any> = [
    {name: 'title', title: 'Title', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip'},
    {name: 'description', title: 'Description', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip'},
    {name: 'dueDate', title: 'Due Date', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip'},
    {name: 'priority', title: 'Priority', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip'},
  ];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  todosList: Array<any> = [];

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private stateService: StateService,
    private clientTodoService: TodoServices,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedYear'] && !changes['selectedYear'].firstChange) {
      this.getTodosList();
    }
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.user = Session.getUser('delegatedFrom').id;
    this.getTodosList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getTodosList() {
    let request = {
            fromIndex: this.index,
            searchKey: ''
        };
    let status = 'Assigned';
    const clientInfo: any = Session.getClient();
    let year = this.selectedYear === 'all'? '': this.selectedYear;
    this.clientTodoService.getAllTodosTableData(this.org, this.user, this.channelType, this.channelId, status, request, this.type, clientInfo,'', year)
                .subscribe(response => {
                    this.todosList = response.toDosList || [];
                }, error => {
                    this.loadingService.triggerLoadingEvent(false);
                });
  }

  navigateToTodoSinglePage(data) {
    this._router.navigate(
      [
        {
          outlets: {
            primary: ['toDo', 'all'], // 👈 split as array
            popup: [
              'client-single-todo',
              'clients',
              data.clientId,
              'toDo',
              data.id
            ]
          }
        }
      ]
    );
  }
}
